import PropTypes from 'prop-types';

const senderShape = PropTypes.shape({
  avatarColor: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
});

const messageShape = PropTypes.shape({
  content: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  sender: senderShape.isRequired,
});

export default messageShape;
